export default {
  login:{
    login:'Log in'
  },
  head:{
    title: 'Chengdu ECHINT Technology Co., Ltd.'
  },
  home:{
    technologies:'Technology',
    overview:'Overview',
    platform:'Technology Platform',
    advantages:'Our Advantages',
    services:'Services',
    panelLevelPackaging:'Panel Level Packaging',
    designSimulation:'Design & Simulation',
    labServices:'Lab Services',
    supportServices:'Support Services',
    contactUs:'Contact Us',
    aboutECHINT:'About ECHINT',
    companyProfile:'Company Profile',
    qualityAssurance:'Quality Assurance',
    compliance:'Compliance Management',
    newsroom:'Newsroom',
    joinUs:'Join Us',
    search:'Search',
    keywords:'keywords',
    year:'year'
  },
  footer:{
    ECHINT: 'Follow us on Wechat',
    Wechat:''
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js